import React from 'react';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, ExternalLink } from 'lucide-react';
import { businessInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company info */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4">
              {businessInfo.name}
            </h3>
            <p className="text-gray-400 mb-4">
              Professional Wash & Fold service with free pickup and delivery. 
              Serving Snellville, Lilburn, Lawrenceville, and Norcross.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-teal-600 hover:bg-teal-700 flex items-center justify-center transition-colors">
                <Facebook size={20} className="text-white" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-teal-600 hover:bg-teal-700 flex items-center justify-center transition-colors">
                <Instagram size={20} className="text-white" />
              </a>
              <a 
                href={businessInfo.googleReviewsUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-teal-600 hover:bg-teal-700 flex items-center justify-center transition-colors"
                title="Google Reviews"
              >
                <ExternalLink size={20} className="text-white" />
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="hover:text-teal-400 transition-colors">Services</a>
              </li>
              <li>
                <a href="#how-it-works" className="hover:text-teal-400 transition-colors">How It Works</a>
              </li>
              <li>
                <a href="#service-areas" className="hover:text-teal-400 transition-colors">Service Areas</a>
              </li>
              <li>
                <a href="#testimonials" className="hover:text-teal-400 transition-colors">Reviews</a>
              </li>
              <li>
                <a href="#book-now" className="hover:text-teal-400 transition-colors">Book Now</a>
              </li>
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone size={18} className="text-teal-400 flex-shrink-0 mt-0.5" />
                <a href={`tel:${businessInfo.phone}`} className="hover:text-teal-400 transition-colors">
                  {businessInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={18} className="text-teal-400 flex-shrink-0 mt-0.5" />
                <a href={`mailto:${businessInfo.email}`} className="hover:text-teal-400 transition-colors break-all">
                  {businessInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={18} className="text-teal-400 flex-shrink-0 mt-0.5" />
                <div>
                  <span className="block font-medium text-white">Drop-Off Location:</span>
                  <span>{businessInfo.address}</span>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Clock size={18} className="text-teal-400 flex-shrink-0 mt-0.5" />
                <div>
                  <span className="block">{businessInfo.laundromat_hours}</span>
                  <span className="text-sm text-gray-400">{businessInfo.washfold_hours}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {currentYear} {businessInfo.name}. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="/terms" className="hover:text-teal-400 transition-colors">Privacy Policy</a>
              <a href="/terms" className="hover:text-teal-400 transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
